<ng-template #modalLG let-modal style="border-radius: 8px;" >

        <div class="modal-header p-0" style="background-color: transparent;">
            <button type="button" class=" close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    <div style="margin: 64px">
        <div class=" text-center mb-4">
            <h4 class="size24">Ajoutez une dépense</h4>
        </div>

        <div class="modal-body p-0" tabindex="0" ngbAutofocus>

            <div class="d-flex justify-content-center align-items-center stepper-wrapper mb-4">

                <div class="step-item" [class.completed]="currentStep > 1">
                    <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
                        <div class="circle">1</div>
                        <span>Type</span>
                    </div>
                    <div class="line"></div>
                </div>

                <div class="step-item" [class.completed]="currentStep > 2">
                    <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
                        <div class="circle">2</div>
                        <span>Informations sur les dépenses</span>
                    </div>
                    <div class="line"></div>
                </div>

                <div class="step-item" [class.completed]="currentStep > 3">
                    <div class="step" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
                        <div class="circle">3</div>
                        <span>Informations complémentaires</span>
                    </div>
                    <div class="line"></div>
                </div>

                <div class="step-item" [class.completed]="currentStep > 4">
                    <div class="step" [class.active]="currentStep === 4" [class.completed]="currentStep > 4">
                        <div class="circle">4</div>
                        <span>Note</span>
                    </div>
                </div>

            </div>
            <!-- Stepper
            <div class="d-flex   stepper-wrapper mb-4">
                <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
                    <div class="circle">1</div>
                    <span>Type et montant</span>
                </div>
                <div class="line"></div>
                <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
                    <div class="circle">2</div>
                    <span>Informations sur les dépenses</span>
                </div>
                <div class="line"></div>
                <div class="step" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
                    <div class="circle">3</div>
                    <span>Informations complémentaires</span>
                </div>
                <div class="line"></div>
                <div class="step p-0 m-0" [class.active]="currentStep === 4" [class.completed]="currentStep > 4">
                    <div class="circle ">4</div>
                    <span>Note</span>
                </div>
                <div class="line"></div>
                <div class="step" [class.active]="currentStep === 5" [class.completed]="currentStep > 5">
                    <div class="circle">5</div>
                    <span>Terminé</span>
                </div>
            </div>-->

            <!-- Example step content -->
            <div *ngIf="currentStep === 1">


                <div class="items " style="margin-bottom: 24px">

                    <div class=" rounded col-lg-12 d-flex flex-wrap p-0" style="gap: 16px;">
                        <label class="type flex-grow-1  cursor-pointer" style="width: 340px"
                               [class.selected]="formData.methode_paiement === 'espece'">
                            <input type="radio" id="espece" name="productType" value="espece" [(ngModel)]="formData.methode_paiement" class="custom-radio">
                            <div>
                               <div class="test">

                                   <i data-feather="map-pin" [size]="16"></i>
                                <label class="size15 " for="espece">Espèces</label>
                               </div>
                                <p class="mb-0"> Rechargez votre portefeuille en utilisant de l'argent liquide provenant de l'une de vos options de paiement enregistrées.</p>
                            </div>


                        </label>

                        <label class="type flex-grow-1  cursor-pointer pr-0" style="width: 340px"
                               [class.selected]="formData.methode_paiement === 'cheque'">

                            <input type="radio" id="cheque" name="productType" value="cheque" [(ngModel)]="formData.methode_paiement" class="custom-radio">
                            <div>
                            <div class="test">
                                <i data-feather="truck" [size]="16"></i>
                                <label class="size15"  for="cheque">Chèque</label>
                            </div>
                                <p class="mb-0">Rechargez votre portefeuille en utilisant un chèque</p>
                            </div>
                        </label>

                    </div>


                </div>
                <!--<div class="d-flex justify-content-end">
                    <button class="btn btn-primary" (click)="nextStep()">Continuer</button>
                </div>-->
            </div>

            <div *ngIf="currentStep === 2">
                <div class="center"  style="margin-bottom: 24px">
                    <label>Catégorie <span class="text-danger">*</span> </label>
                    <div class="mb-2">
                        <select class="form-control" 
                                [(ngModel)]="formData.categorie" 
                                name="categorie" 
                                required
                                [disabled]="categories.length === 0">
                            <option value="">-----</option>
                            <option *ngFor="let cat of categories" [value]="cat.id">{{ cat.nom }}</option>
                        </select>
                        <small *ngIf="categories.length === 0" class="text-muted">Chargement des catégories...</small>
                    </div>

                </div>
                <div class="items"  style="margin-bottom: 24px">

                    <div class="col-lg-12 p-0">
                        <label>Montant <span class="text-danger">*</span> </label>
                        <input type="number"
                               class="form-control"
                               [(ngModel)]="formData.montant"
                               name="montant"
                               step="0.001"
                               min="0"
                               required>
                    </div>

                </div>

            </div>

            <div *ngIf="currentStep=== 3">
                <div class="center"  style="margin-bottom: 24px">
                    <div style="flex-grow: 1;">
                        <label>Date de règlement <span class="text-danger">*</span> </label>
                        <input type="date"
                               class="form-control"
                               [(ngModel)]="formData.date_reglement"
                               name="date_reglement"
                               required>
                    </div>
                </div>

            </div>
            <div *ngIf="currentStep===4">
                <div class="center "  style="margin-bottom: 24px">
                    <label>Note</label>
                    <textarea type="text"
                              class="form-control"
                              [(ngModel)]="formData.note"
                              name="note"
                              rows="3"> </textarea>
                </div>
            </div>

            <div *ngIf="currentStep === 5" class="text-center">
                <p class="text-success">✅ Dépense ajoutée avec succès !</p>
                <button class="btn btn-secondary" (click)="resetStepper()">Ajouter une autre</button>
            </div>



        </div>
        <div class="centerButtons">

            <button *ngIf="currentStep > 1" type="button" class="btn btn-grey"
                    (click)="prevStep()" rippleEffect>
                Retour
            </button>
            <button *ngIf="currentStep === 1" type="button" class="btn btn-grey" (click)="modal.close('Accept click')" rippleEffect>
                Annuler
            </button>

            <button *ngIf="currentStep === 3" type="button" class="btn btn-primary"
                    (click)="nextStep()" rippleEffect>
                Ajout rapide
            </button>
            <button *ngIf="currentStep < 4" type="button" class="btn btn-primary"
                    (click)="nextStep()" rippleEffect>
                Continuer
            </button>
            <button *ngIf="currentStep === 4" type="button" class="btn btn-primary"
                    (click)="validateDepense()"
                    [disabled]="isLoading"
                    rippleEffect>
                <span *ngIf="isLoading">Enregistrement...</span>
                <span *ngIf="!isLoading">Valider</span>
            </button>
        </div>

    </div>
</ng-template>

